import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03c5b2b6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c5b2b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c5b2b6')) {
      api.createRecord('03c5b2b6', component.options)
    } else {
      api.reload('03c5b2b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03c5b2b6&scoped=true&", function () {
      api.rerender('03c5b2b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SingleFileUploader/index.vue"
export default component.exports